export const retro = [
  {
    number: 'RBB100',
    hasModel: false
  },
  {
    number: 'RBB101',
    hasModel: false
  },
  {
    number: 'RBB102',
    hasModel: false
  },
  {
    number: 'RBB103',
    hasModel: false
  },
  {
    number: 'RBB104',
    hasModel: false
  },
  {
    number: 'RBB105',
    hasModel: false
  },
  {
    number: 'RBB106',
    hasModel: false
  },
  {
    number: 'RBB107',
    hasModel: false
  },
  {
    number: 'RBB108',
    hasModel: false
  },
  {
    number: 'RBB109',
    hasModel: false
  },
  {
    number: 'RBB110',
    hasModel: false
  },
  {
    number: 'RBB111',
    hasModel: false
  },
  {
    number: 'RBB112',
    hasModel: false
  },
  {
    number: 'RBB113',
    hasModel: false
  },
  {
    number: 'RBB114',
    hasModel: false
  },
  {
    number: 'RBB115',
    hasModel: false
  },
  {
    number: 'RBB116',
    hasModel: false
  },

]